import { VisualizatorSettings } from "../../visualizator-settings";
import { ObjectCreator } from "../../../../../../../web-graphics";

export class PlotContentSettings extends VisualizatorSettings {
  constructor(settings) {
    super();
    for (const key of Object.getOwnPropertyNames(settings)) {
      if (key == "name") {
        this.name = settings.name;
      } else if (key == "settings") {
        this.settings = settings.settings.copy();
      } else {
        if (typeof settings[key] === "object" && settings[key].copy !== undefined) {
          this[key] = settings[key].copy();
        } else if (typeof settings[key] !== "function") {
          this[key] = ObjectCreator.deepCopy(settings[key]);
        }
      }
    }
  }

  copy() {
    return new PlotContentSettings(this);
  }
}
